export const appointmentTime = [
  {
    id: 1,
    time: "9:00AM",
  },
  {
    id: 2,
    time: "10:00AM",
  },
  {
    id: 3,
    time: "11:00AM",
  },
  {
    id: 4,
    time: "12:00PM",
  },
  {
    id: 5,
    time: "01:00PM",
  },
  {
    id: 6,
    time: "02:00PM",
  },
  {
    id: 7,
    time: "03:00PM",
  },
  {
    id: 8,
    time: "04:00PM",
  }
];
